import { render, staticRenderFns } from "./ChangeDateOfRegistration.vue?vue&type=template&id=10e18f44&scoped=true&"
import script from "./ChangeDateOfRegistration.vue?vue&type=script&lang=js&"
export * from "./ChangeDateOfRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDateOfRegistration.vue?vue&type=style&index=0&id=10e18f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e18f44",
  null
  
)

export default component.exports